import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyObject from './JoyObject';
import JoyComment from './JoyComment';
import JoyDataService from '../services/JoyDataService';
import { isJoyPropertiesArray, isJoyStatus, isJoyFieldMap, isJoyFieldMapArray } from '../validation/ModelValidation';
import { isString, isNumber, isDate, isUrl, isStringArray, isBoolean, isColor } from '../validation/TypeChecking';
import Color from '../utils/Color';
import { compareProps, compareComments, compareStringArrays } from '../utils/Utils';
export default class JoyMedium extends JoyObject {
    /**
     * Create a new JoyMedium object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        super({
            id: data[JoyField.id],
            objectId: data[JoyField.objectId],
            createdAt: data[JoyField.createdAt],
            createdBy: data[JoyField.createdBy],
        });
        this.fields = [JoyField.likes, JoyField.count, JoyField.comments, JoyField.props, JoyField.isPublic];
        this.objectType = JoyObjectType.medium;
        this.update = (update) => {
            console.log('new updates for medium: ' + this.id);
            let changes = [];
            let status = update[JoyField.status];
            if (isJoyStatus(status) && this._status !== status) {
                this._status = status;
                changes.push(JoyField.status);
            }
            let isPublic = update[JoyField.isPublic];
            if (isBoolean(isPublic) && this._isPublic !== isPublic) {
                this._isPublic = isPublic;
                changes.push(JoyField.isPublic);
            }
            let properties = update[JoyField.props];
            if (isJoyPropertiesArray(properties) && compareProps(this._properties, properties)) {
                this._properties = properties;
                changes.push(JoyField.props);
            }
            let albums = update[JoyField.albums];
            if (isStringArray(albums) && !compareStringArrays(albums, this._albums)) {
                this._albums = albums;
                changes.push(JoyField.albums);
            }
            let likes = update[JoyField.likes];
            if (isStringArray(likes) && !compareStringArrays(likes, this._likes)) {
                this._likes = likes;
                changes.push(JoyField.likes);
            }
            let commentsCount = update[JoyField.count];
            if (isNumber(commentsCount) && this._commentsCount !== commentsCount) {
                this._commentsCount = commentsCount;
                changes.push(JoyField.count);
            }
            let commentsData = update[JoyField.comments];
            if (isJoyFieldMapArray(commentsData)) {
                let recentComments = [];
                for (const commentData of commentsData) {
                    try {
                        recentComments.push(new JoyComment(commentData));
                    }
                    catch (error) {
                        throw Error('Invalid input for JoyComment.');
                    }
                }
                if (!compareComments(this._recentComments, recentComments)) {
                    this._recentComments = recentComments;
                    changes.push(JoyField.comments);
                }
            }
            let takenAt = update[JoyField.takenAt];
            if (isDate(takenAt)) {
                let exists = isDate(this._takenAt);
                if (!exists || (exists && this._takenAt !== takenAt)) {
                    this._takenAt = takenAt;
                    changes.push(JoyField.takenAt);
                }
            }
            let mimeType = update[JoyField.mimeType];
            if (isString(mimeType)) {
                let exists = isString(this._mimeType);
                if (!exists || (exists && this._mimeType !== mimeType)) {
                    this._mimeType = mimeType;
                    changes.push(JoyField.mimeType);
                }
            }
            let width = update[JoyField.width];
            if (isNumber(width)) {
                let exists = isNumber(this._width);
                if (!exists || (exists && this._width !== width)) {
                    this._width = width;
                    changes.push(JoyField.width);
                }
            }
            let height = update[JoyField.height];
            if (isNumber(height)) {
                let exists = isNumber(this._height);
                if (!exists || (exists && this._height !== height)) {
                    this._height = height;
                    changes.push(JoyField.height);
                }
            }
            let duration = update[JoyField.duration];
            if (isNumber(duration)) {
                let exists = isNumber(this._duration);
                if (!exists || (exists && this._duration !== duration)) {
                    this._duration = duration;
                    changes.push(JoyField.duration);
                }
            }
            let data = update[JoyField.meanColor];
            if (isJoyFieldMap(data)) {
                let red = data[JoyField.red];
                let green = data[JoyField.green];
                let blue = data[JoyField.blue];
                if (isNumber(red) && isNumber(green) && isNumber(blue)) {
                    let meanColor = new Color(red, green, blue);
                    let exists = isColor(this._meanColor);
                    if (!exists || (exists && !this._meanColor.isEqual(meanColor))) {
                        this._meanColor = meanColor;
                        changes.push(JoyField.meanColor);
                    }
                }
            }
            let thumbnailUri = update[JoyField.thumbnailUri];
            if (isUrl(thumbnailUri)) {
                let exists = isUrl(this._thumbnailUri);
                if (!exists || (exists && this._thumbnailUri !== thumbnailUri)) {
                    this._thumbnailUri = thumbnailUri;
                    changes.push(JoyField.thumbnailUri);
                }
            }
            let downloadUri = update[JoyField.downloadUri];
            if (isUrl(downloadUri)) {
                let exists = isUrl(this._downloadUri);
                if (!exists || (exists && this._downloadUri !== downloadUri)) {
                    this._downloadUri = downloadUri;
                    changes.push(JoyField.downloadUri);
                }
            }
            let streamUriHls = update[JoyField.streamUriHls];
            if (isUrl(streamUriHls)) {
                let exists = isUrl(this._streamUriHls);
                if (!exists || (exists && this._streamUriHls !== streamUriHls)) {
                    this._streamUriHls = streamUriHls;
                    changes.push(JoyField.streamUriHls);
                }
            }
            let streamUriMpd = update[JoyField.streamUriMpd];
            if (isUrl(streamUriMpd)) {
                let exists = isUrl(this._streamUriMpd);
                if (!exists || (exists && this._streamUriMpd !== streamUriMpd)) {
                    this._streamUriMpd = streamUriMpd;
                    changes.push(JoyField.streamUriMpd);
                }
            }
            if (changes.length > 0) {
                super.notifyObservers(changes);
            }
        };
        if (!isString(data[JoyField.group])) {
            throw Error('Invalid field group.');
        }
        this.groupId = data[JoyField.group];
        if (!isJoyPropertiesArray(data[JoyField.props])) {
            throw Error('Invalid field props.');
        }
        this._properties = data[JoyField.props];
        if (!isBoolean(data[JoyField.isPublic])) {
            throw Error('Invalid field isPublic.');
        }
        this._isPublic = data[JoyField.isPublic];
        if (!isJoyStatus(data[JoyField.status])) {
            throw Error('Invalid field status.');
        }
        this._status = data[JoyField.status];
        if (!isStringArray(data[JoyField.albums])) {
            throw Error('Invalid field albums.');
        }
        this._albums = data[JoyField.albums];
        if (!isStringArray(data[JoyField.likes])) {
            throw Error('Invalid field likes.');
        }
        this._likes = data[JoyField.likes];
        if (!isNumber(data[JoyField.count])) {
            throw Error('Invalid field count.');
        }
        this._commentsCount = data[JoyField.count];
        if (!isJoyFieldMapArray(data[JoyField.comments])) {
            throw Error('Invalid field comments.');
        }
        this._recentComments = [];
        for (const commentData of data[JoyField.comments]) {
            try {
                this._recentComments.push(new JoyComment(commentData));
            }
            catch (error) {
                throw Error('Invalid input for JoyComment.');
            }
        }
        if (isDate(data[JoyField.takenAt])) {
            this._takenAt = data[JoyField.takenAt];
        }
        else {
            this._takenAt = null;
        }
        if (isString(data[JoyField.mimeType])) {
            this._mimeType = data[JoyField.mimeType];
        }
        else {
            this._mimeType = null;
        }
        if (isNumber(data[JoyField.width])) {
            this._width = data[JoyField.width];
        }
        else {
            this._width = null;
        }
        if (isNumber(data[JoyField.height])) {
            this._height = data[JoyField.height];
        }
        else {
            this._height = null;
        }
        if (isNumber(data[JoyField.duration])) {
            this._duration = data[JoyField.duration];
        }
        else {
            this._duration = null;
        }
        if (isJoyFieldMap(data[JoyField.meanColor])) {
            let meanColorData = data[JoyField.meanColor];
            let red = meanColorData[JoyField.red];
            let green = meanColorData[JoyField.green];
            let blue = meanColorData[JoyField.blue];
            if (isNumber(red) && isNumber(green) && isNumber(blue)) {
                this._meanColor = new Color(red, green, blue);
            }
        }
        else {
            this._meanColor = null;
        }
        if (isUrl(data[JoyField.thumbnailUri])) {
            this._thumbnailUri = data[JoyField.thumbnailUri];
        }
        else {
            this._thumbnailUri = null;
        }
        if (isUrl(data[JoyField.downloadUri])) {
            this._downloadUri = data[JoyField.downloadUri];
        }
        else {
            this._downloadUri = null;
        }
        if (isUrl(data[JoyField.streamUriHls])) {
            this._streamUriHls = data[JoyField.streamUriHls];
        }
        else {
            this._streamUriHls = null;
        }
        if (isUrl(data[JoyField.streamUriMpd])) {
            this._streamUriMpd = data[JoyField.streamUriMpd];
        }
        else {
            this._streamUriMpd = null;
        }
        this.initialUpdate = JoyMedium.fields;
        let listenerData = new Map();
        listenerData[JoyField.objectType] = this.objectType;
        listenerData[JoyField.id] = this.id;
        listenerData[JoyField.group] = this.groupId;
        this.listener = JoyDataService.instance.documentListener(listenerData, this.update);
    }
    get status() {
        return this._status;
    }
    get isPublic() {
        return this._isPublic;
    }
    get properties() {
        return this._properties;
    }
    get albums() {
        return this._albums;
    }
    get likes() {
        return this._likes;
    }
    get commentsCount() {
        return this._commentsCount;
    }
    get recentComments() {
        return this._recentComments;
    }
    get takenAt() {
        return this._takenAt;
    }
    get mimeType() {
        return this._mimeType;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get duration() {
        return this._duration;
    }
    get meanColor() {
        return this._meanColor;
    }
    get thumbnailUri() {
        return this._thumbnailUri;
    }
    get downloadUri() {
        return this._downloadUri;
    }
    get streamUriHls() {
        return this._streamUriHls;
    }
    get streamUriMpd() {
        return this._streamUriMpd;
    }
    //Helpers
    /**
     * Set the isPublic field of the document.
     * @param isPublic A boolean.
     */
    async setPublic(isPublic) {
        let data = new Map();
        data[JoyField.isPublic] = isPublic;
        data[JoyField.group] = this.groupId;
        return this.updateData(data);
    }
    /**
     * Set the albums field of the document.
     * @param albums An array strings identifying Album documents.
     */
    async setAlbums(albums) {
        let data = new Map();
        data[JoyField.albums] = albums;
        data[JoyField.group] = this.groupId;
        return this.updateData(data);
    }
    /**
     * Set the likes field of the document.
     * @param like A boolean indicating if the user likes the medium.
     */
    async setLike(like) {
        let data = new Map();
        data[JoyField.likes] = like;
        data[JoyField.group] = this.groupId;
        return this.updateData(data);
    }
}
//# sourceMappingURL=JoyMedium.js.map